import { render, staticRenderFns } from "./AntecedentesGinecologicos.vue?vue&type=template&id=d713a8c0"
import script from "./AntecedentesGinecologicos.vue?vue&type=script&lang=js"
export * from "./AntecedentesGinecologicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports